import { useState } from 'react';

import { ThresholdKindType } from '@/types';

const useSelectedThreshold = () => {
  const [selectedThreshold, setSelectedThreshold] = useState<ThresholdKindType>('production');

  return { selectedThreshold, setSelectedThreshold };
};

export default useSelectedThreshold;
